<template>
  <div class="root-layout d-flex flex-column">
    <TopNav />
    <CommandPalette v-if="isAdmin" />
    <AdminNav v-if="isAdmin && isAdminRoute" />
    <div class="flex-grow-1 overflow-auto">
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
import AdminNav from "@/admin/navigation/AdminNav.vue";
import TopNav from "@/root/TopNav.vue";
import CommandPalette from "@/components/common/CommandPalette.vue";
import { useCommandPaletteCommands } from "@/composables/useCommandPaletteCommands";
import { isAdminPath } from "@/router/adminPath";
import { computed } from "vue";
import { useRoute } from "vue-router";

const { isAdmin } = useCommandPaletteCommands();

const route = useRoute();
const isAdminRoute = computed(() => isAdminPath(route.path));
</script>

<style scoped lang="scss">
.root-layout {
  overflow: auto;
  height: 100%; /* Use height instead of vh-100 to work with App's container */
}
</style>
